import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import produce, { applyPatches as _applyPatches } from 'immer';
import { DEFAULT_VIEW_KEY, DATABASE_SCHEMA_VERSION } from '../constants';
import Column from './Column';
import Record from './Record';
import Field from './Field';
import Views from './Views';
var Value = {
  getDefaults: function getDefaults() {
    var currentUserId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return {
      attributes: {
        version: DATABASE_SCHEMA_VERSION,
        title: '',
        createdAt: Date.now(),
        createdBy: currentUserId,
        updatedAt: Date.now(),
        updatedBy: currentUserId
      },
      records: {},
      columns: {},
      views: _defineProperty({}, DEFAULT_VIEW_KEY, Views.create({
        key: 'default'
      }))
    };
  },
  create: function create() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var currentUserId = arguments.length > 1 ? arguments[1] : undefined;
    return _objectSpread({}, Value.getDefaults(currentUserId), {}, attrs);
  },
  applyAction: function applyAction() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Value.getDefaults();

    var _ref = arguments.length > 1 ? arguments[1] : undefined,
        type = _ref.type,
        _ref$payload = _ref.payload,
        payload = _ref$payload === void 0 ? {} : _ref$payload;

    var changes = [];
    var inverseChanges = [];
    var updatedValue = produce(value, function (draftValue) {
      var tmp = {};

      switch (type) {
        case 'setAttributes':
          Object.entries(payload.attrs).forEach(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
                key = _ref3[0],
                value = _ref3[1];

            draftValue.attributes[key] = value;
          });
          draftValue.attributes.updatedAt = new Date().getTime();
          draftValue.attributes.updatedBy = payload.currentUserId;
          return;

        case 'setView':
          Object.entries(payload.attrs).forEach(function (_ref4) {
            var _ref5 = _slicedToArray(_ref4, 2),
                key = _ref5[0],
                value = _ref5[1];

            draftValue.views[payload.key][key] = value;
          });
          return;

        case 'insertColumn':
          tmp.newColumn = Column.create(_objectSpread({}, payload.attrs, {
            createdBy: payload.currentUserId,
            updatedAt: new Date().getTime(),
            updatedBy: payload.currentUserId
          }));
          draftValue.columns[tmp.newColumn.key] = tmp.newColumn;
          return;

        case 'deleteColumn':
          delete draftValue.columns[payload.columnKey];
          Object.keys(draftValue.views).forEach(function (viewKey) {
            delete draftValue.views[viewKey].sorts[payload.columnKey];
          });
          return;

        case 'insertRecord':
          tmp.newRecord = Record.create(_objectSpread({}, payload.attrs, {
            createdBy: payload.currentUserId,
            updatedAt: new Date().getTime(),
            updatedBy: payload.currentUserId
          }));
          draftValue.records[tmp.newRecord.key] = tmp.newRecord;
          return;

        case 'setColumn':
          Object.entries(payload.attrs).forEach(function (_ref6) {
            var _ref7 = _slicedToArray(_ref6, 2),
                key = _ref7[0],
                value = _ref7[1];

            draftValue.columns[payload.key][key] = value;
          });
          draftValue.columns[payload.key].updatedAt = new Date().getTime();
          draftValue.columns[payload.key].updatedBy = payload.currentUserId;
          return;

        case 'mergeFieldData':
          // Create the field if not yet
          if (!draftValue.records[payload.recordKey].fields[payload.columnKey]) {
            draftValue.records[payload.recordKey].fields[payload.columnKey] = Field.create({
              createdBy: payload.currentUserId,
              updatedAt: new Date().getTime(),
              updatedBy: payload.currentUserId,
              columnKey: payload.columnKey,
              data: payload.data
            });
          } else {
            Object.entries(payload.data).forEach(function (_ref8) {
              var _ref9 = _slicedToArray(_ref8, 2),
                  key = _ref9[0],
                  value = _ref9[1];

              if (draftValue.records[payload.recordKey].fields[payload.columnKey].data[key] === value) {
                return; // Ignore if value has not changed
              }

              draftValue.records[payload.recordKey].fields[payload.columnKey].data[key] = value;
              draftValue.records[payload.recordKey].updatedAt = new Date().getTime();
              draftValue.records[payload.recordKey].updatedBy = payload.currentUserId;
            });
          }

          return;

        case 'deleteField':
          delete draftValue.records[payload.recordKey].fields[payload.columnKey];
          return;

        case 'deleteRecord':
          delete draftValue.records[payload.recordKey];
          return;

        default:
          return;
      }
    }, function (patches, inversePatches) {
      changes.push.apply(changes, _toConsumableArray(patches));
      inverseChanges.push.apply(inverseChanges, _toConsumableArray(inversePatches));
    });
    return {
      value: updatedValue,
      changes: changes,
      inverseChanges: inverseChanges
    };
  },
  applyPatches: function applyPatches() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Value.getDefaults();
    var patches = arguments.length > 1 ? arguments[1] : undefined;
    return _applyPatches(value, patches);
  }
};
export default Value;